import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import seo from "./seo";
import "@/assets/sass/main.scss";
createApp(App).use(store).use(seo).use(router).mount("#app");
